<div class="file-upload">
  <div class="card">
    <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="static-1">
      <ngb-panel id="static-1">
        <ng-template ngbPanelTitle class="p-0 m-0">
          <div class="card-header d-flex justify-content-between py-2">
            <p class="m-0 file-title">File Upload</p>
            <!-- <input type="file" #fileInput multiple (change)="addToQueue()" /> -->
             <!-- <button class="btn btn-sm" (click)="acc.toggle('static-1')">collapse</button> -->
              <button type="button" class="close text-white" data-dismiss="modal"  (click)="close()">
                  &times;
              </button>
          </div>

        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card p-0">
            <div class="card-body p-0">
              <!-- <div *ngFor="let item of queue | async" >
                <div class="d-flex justify-content-between my-3">
                  <p class="m-0">{{ item?.file?.name }}</p>
                  <p class="m-0" *ngIf="item.isPending()">{{ item.progress + ' %' }}</p>
                  <p class="m-0" *ngIf="item.isSuccess()">{{ item.progress + ' %' }}</p>
                  <p class="m-0" *ngIf="item.inProgress()">{{ item.progress + ' %' }}</p>
                  <p class="m-0" *ngIf="item.isError()">{{ item.progress + ' %' }}</p>

                  <span *ngIf="item.isPending()" class="tag tag-default"></span>
                  <span *ngIf="item.isSuccess()" class="tag tag-success"></span>
                  <span *ngIf="item.inProgress()" class="tag tag-warning"></span>
                  <span *ngIf="item.isError()" class="tag tag-danger"></span>

                    <a tooltip="Upload file" (click)="item.upload()" *ngIf="item.isUploadable()">
                      <i class="fa fa-upload"></i>
                    </a>
                    <a tooltip="Cancel upload" (click)="item.cancel()" *ngIf="item.inProgress()">
                      <i class="fa fa-times-circle"></i>
                    </a>
                    <a tooltip="Remove from queue" (click)="item.remove()" *ngIf="!item.inProgress()">
                      <i class="fa fa-trash"></i>
                    </a>
                </div>

                <hr class="m-0">
              </div> -->
              <table class="table table-headed table-striped">
                <tbody>
                  <tr *ngFor="let item of queue | async">
                    <td>
                      <p class="fixed-width">{{ item?.file?.name }}</p>
                    </td>
                    <!-- <td class="text-right">{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td> -->
                    <td>{{ item.progress + ' %' }}</td>
                    <!-- <td>
                      <span *ngIf="item.isPending()" class="tag tag-default"></span>
                      <span *ngIf="item.isSuccess()" class="tag tag-success"></span>
                      <span *ngIf="item.inProgress()" class="tag tag-warning"></span>
                      <span *ngIf="item.isError()" class="tag tag-danger"></span>
                    </td> -->
                    <td class="text-right">
                      <!-- <a tooltip="Upload file" (click)="item.upload()" *ngIf="item.isUploadable()">
                        <i class="fa fa-upload"></i>
                      </a> -->
                      <circle-progress *ngIf="item.inProgress() && item.progress <= 100"
                          [percent]="item.progress"
                          [radius]="8"
                          [backgroundPadding]="4"
                          [showBackground]="true"
                          [clockwise]="true"
                          [backgroundColor]="'#FFFFFF'"
                          [showTitle]="false"
                          [showUnits]="false"
                          [showSubtitle]="false"
                          [outerStrokeWidth]="3"
                          [innerStrokeWidth]="4"
                          [showInnerStroke]="false"
                          [outerStrokeColor]="' #11ff00'"
                          [animation]="true"
                          [animationDuration]="0"
                        ></circle-progress>
                        <img *ngIf="!item.inProgress() && item.progress==100" height="22" class="rounded-circle" src="assets/images/submittedicon.png" alt="">
                        <a tooltip="Upload file" (click)="item.upload()" *ngIf="item.isUploadable()">
                          <i class="fa fa-upload mx-1"></i>
                        </a>
                      <a tooltip="Cancel upload" (click)="item.cancel()" *ngIf="item.inProgress()">
                        <i class="fa fa-times-circle mx-1"></i>
                      </a>
                      <a tooltip="Remove from queue" (click)="item.remove()" *ngIf="!item.inProgress()">
                        <i class="fa fa-trash mx-1"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div class="card-footer">
                <a class="btn btn-sm" (click)="uploader.clearQueue()">Clear queue</a>
                <a class="btn btn-primary btn-sm" (click)="uploader.uploadAll()">Upload all</a>
            </div> -->
          </div>
        </ng-template>
      </ngb-panel>


    </ngb-accordion>

    <!-- <div class="card-header d-flex justify-content-between py-2">
      <h5 class="m-0">File Uplaod</h5>
        <button type="button" class="close text-white" data-dismiss="modal" (click)="close()">
            &times;
        </button>
    </div>
    <div class="card-body p-0">
      <table class="table table-headed table-striped">
        <tbody>
          <tr *ngFor="let item of queue | async">
            <td>
              <p class="fixed-width">{{ item?.file?.name }}</p>
            </td>
            <td>{{ item.progress + ' %' }}</td>

            <td class="text-right">

              <circle-progress *ngIf="item.progress < 100"
                  [percent]="item.progress"
                  [radius]="8"
                  [backgroundPadding]="4"
                  [showBackground]="true"
                  [clockwise]="true"
                  [backgroundColor]="'#FFFFFF'"
                  [showTitle]="false"
                  [showUnits]="false"
                  [showSubtitle]="false"
                  [outerStrokeWidth]="3"
                  [innerStrokeWidth]="4"
                  [showInnerStroke]="false"
                  [outerStrokeColor]="' #11ff00'"
                  [animation]="true"
                  [animationDuration]="300"
                ></circle-progress>
                <img *ngIf="item.progress == 100" height="22" class="rounded-circle" src="assets/images/submittedicon.png" alt="">

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer">

    </div> -->




  </div>
</div>

<!-- <div class="file-upload">
  <div class="row">

    <div class="col-md-3">
      <h3>Select files</h3>
      <input type="file" #fileInput multiple (change)="addToQueue()" />
    </div>

    <div class="col-md-9">
      <h3>Upload queue</h3>
      <table class="table table-headed table-striped">
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-right">Size</th>
            <th class="text-left">Progress</th>
            <th class="text-left">Status</th>
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of queue | async">
            <td>{{ item?.file?.name }}</td>
            <td class="text-right">{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
            <td>{{ item.progress + ' %' }}</td>
            <td>
              <span *ngIf="item.isPending()" class="tag tag-default"></span>
              <span *ngIf="item.isSuccess()" class="tag tag-success"></span>
              <span *ngIf="item.inProgress()" class="tag tag-warning"></span>
              <span *ngIf="item.isError()" class="tag tag-danger"></span>
            </td>
            <td class="text-right">
              <a tooltip="Upload file" (click)="item.upload()" *ngIf="item.isUploadable()">
                <i class="fa fa-upload"></i>
              </a>
              <a tooltip="Cancel upload" (click)="item.cancel()" *ngIf="item.inProgress()">
                <i class="fa fa-times-circle"></i>
              </a>
              <a tooltip="Remove from queue" (click)="item.remove()" *ngIf="!item.inProgress()">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <a class="button" (click)="uploader.clearQueue()">Clear queue</a>
        <a class="button button-primary" (click)="uploader.uploadAll()">Upload all</a>
      </div>
    </div>

  </div>

</div> -->
